export function isMobile() {
  return /Mobi|Android|iPhone/i.test(navigator.userAgent);
}